import {useState, useEffect} from 'react';
import {
  TableColumn,
} from "../../../components/CommnTable/CustomDataTable";
import { PastStudentEvaluationList } from "../../../types/types";
import { Button, Box, Card } from "@mui/material";
import { blue } from '@mui/material/colors';
import { useNavigate, useParams } from "react-router-dom";
import { useLoader } from "../../../Loader/LoaderContext";
import { useGet } from "../../../services/hooks/useGet";
import { GetUrl } from "../../../api/endpointConfig";
import {formatDate} from "../../../utils/common";

const usePastStudentEvaluation = () => {
  const navigate = useNavigate()

   const { showLoader, hideLoader } = useLoader();
    const [offsetValue, setOffsetValue] = useState<number>(0);
    const [limitValue, setLimitValue] = useState<number>(10);
    const { id } = useParams();
    const studentEvaluationDetail = JSON.parse(localStorage.getItem("StudentEvaluation") || "{}");

    const { data = [], isLoading, isError } = useGet<any>(
      `${GetUrl.getEvaluationByScholarshipId}/${id}?offset=${offsetValue}&limit=${limitValue}`
    );
  
    const HandlePagination = (e: any) => {
      setOffsetValue(e.page * e.rows); // event.page usually gives pageIndex
  setLimitValue(e.rows);
  
    }
  
    useEffect(() => {
      if (isLoading && !isError) {
        showLoader()
      } else if (isError) { hideLoader() }
      else { hideLoader() }
    }, [isLoading, isError])


  const columns: TableColumn<PastStudentEvaluationList>[] = [
    { field: "evaluator_name", header: "Evaluator Name", sortable: true, width: "2rem", customBody: (row) => (
      <>{studentEvaluationDetail?.name}</>
    ) },
    { field: "interview_date", header: "Evaluation Date", sortable: true, width: "2rem", customBody: (row) => (
      <>{formatDate(row.interview_date)}</>
    ) },
    { field: "evaluation_outcome", header: "Evaluation Remarks", sortable: true, width: "12rem", maxWidth: "16rem" },
    {field: "action", header: "Action", width: "1rem", customBody: (row) => (
        <Button variant="contained" sx={{ bgcolor: blue[700], m: 1, width: "70%" }} onClick={() =>
            navigate(`/student-evaluation-new/${row.id}`)}>View</Button>
      )
    }
  ];

  return { columns, data, limitValue, HandlePagination, studentEvaluationDetail }
}

export default usePastStudentEvaluation